<template>
  <div>
    <div v-if="isLoading === false">
      <div
        class="tw-mb-8 tw-flex sm:tw-justify-between tw-items-center tw-w-full"
        :class="{ 'tw-left-timeline': orientation == 'left', 'tw-right-timeline': orientation == 'right', 'sm:tw-flex-row-reverse': orientation == 'left' }"
      >
        <div class="tw-order-1 sm:tw-w-5/12"></div>
        <component :is="icon" class="tw-w-8 tw-h-8 tw-p-1.5 tw-rounded-full tw-bg-primary-100 tw-text-primary tw-z-10 tw-mr-2 sm:tw-mx-0 tw-order-1" />
        <div class="tw-order-1 tw-bg-white tw-rounded-lg tw-shadow-md tw-w-5/6 sm:tw-w-5/12 tw-px-6 tw-py-4">
          <p class="tw-font-base tw-text-gray-800 tw-text-normal">{{ title }}</p>
          <p class="tw-text-xs tw-leading-snug tw-tracking-wide tw-text-gray-500 tw-text-opacity-100">
            {{ subheading }}
          </p>
          <p
            v-if="textValue"
            v-html="textValue"
            class="tw-mt-2 tw-text-sm tw-font-base tw-leading-snug tw-tracking-wide tw-text-gray-800 tw-text-opacity-100 tw-flex tw-flex-wrap"
          ></p>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        class="tw-mb-8 tw-flex sm:tw-justify-between tw-items-center tw-w-full"
        :class="{ 'tw-left-timeline': orientation == 'left', 'tw-right-timeline': orientation == 'right', 'sm:tw-flex-row-reverse': orientation == 'left' }"
      >
        <div class="tw-order-1 sm:tw-w-5/12"></div>
        <td class="tw-w-8 tw-h-8 tw-z-20 tw-mr-2 sm:tw-mx-0 tw-order-1">
          <base-skeleton-loader class="tw-h-8 tw-w-8 tw-rounded-full" />
        </td>
        <div class="tw-order-1 tw-bg-white tw-rounded-lg tw-shadow-lg tw-w-5/6 sm:tw-w-5/12 tw-px-6 tw-py-4">
          <base-skeleton-loader class="tw-h-4 tw-w-24 tw-mt-2" />
          <base-skeleton-loader class="tw-h-2 tw-w-12 tw-mt-1" />
          <base-skeleton-loader class="tw-h-3 tw-w-full tw-mt-2" />
          <base-skeleton-loader class="tw-h-3 tw-w-full tw-mt-1" />
          <base-skeleton-loader class="tw-h-3 tw-w-3/4 tw-mt-1" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CommentIcon, UserIcon, ListIcon, CheckIcon } from "@/assets/svgs";

export default {
  name: "TimelineCard",
  components: { CommentIcon, UserIcon, ListIcon, CheckIcon },
  props: {
    title: String,
    subheading: String,
    textValue: String,
    iconName: { type: String, default: "list", validator: (value) => ["user", "list", "comment", "check"].indexOf(value) !== -1 },
    orientation: { type: String, default: "right", validator: (value) => ["right", "left"].indexOf(value) !== -1 },
    isLoading: { type: Boolean, default: false },
  },
  computed: {
    icon() {
      switch (this.iconName) {
        case "user":
          return "user-icon";
        case "list":
          return "list-icon";
        case "comment":
          return "comment-icon";
        case "check":
          return "check-icon";
        default:
          return "list-icon";
      }
    },
  },
};
</script>
